import React, { useState } from "react";
import styles from "./styles/Toggle.module.css";

export default function Toggle({ onToggle, active }) {
  const [isActive, setIsActive] = useState(active);

  function toggle() {
    const active = !isActive;
    setIsActive(active);
    onToggle(active);
  }

  const contStyle = isActive ? styles.cont + " " + styles.active : styles.cont;
  const circleStyle = isActive
    ? styles.circle + " " + styles.active
    : styles.circle;

  return (
    <div className={contStyle} onClick={() => toggle()}>
      <div className={circleStyle}></div>
    </div>
  );
}
